<!--Navbar-->
<pmd-navbar class="navbar-expand-xl fixed-top navbar-light bg-white py-1 pmd-z-depth-3 border-bottom" id="navbar">
	<app-customer-navbar></app-customer-navbar>
</pmd-navbar>
<!--/.Navbar-->

<!--Main Content Area-->
<main class="pmd-content customer-layout" id="mainContent">
	<router-outlet></router-outlet>
</main>

<div class="pmd-footer border-top" style="pointer-events: none;">
	<div class="container-fluid">
	   <div class="row pmd-site-info">
		  <div class="col-12 col-md mb-2 mb-md-0">
			<p><b>Want to create invoices for your business?</b> Visit <a href="https://www.paykanz.com/invoice" target="_blank">www.paykanz.com/invoice</a> and get started instantly.</p>
		  </div>
		  <div class="col-md-auto col-12">
			<p>Powered by <a href="https://www.paykanz.com/invoice" target="_blank">PayKanz</a>.</p>
		  </div>
	   </div>
	</div>
</div>